import { Form, Formik } from "formik";
import { useState } from "react";
import { useIntl } from "react-intl";
import * as Yup from "yup";

import { useRemoveBasket } from "../../context/useMutation";
import { useGetBasket } from "../../context/useQuery";
import { useMarket } from "../../hook";
import { StepHeader, StepOne, StepSuccess, StepThree, StepTwo } from "./component";

export default function MarketPlace() {
  useGetBasket();
  const { basket, basketId } = useMarket()
  const { mutateAsync } = useRemoveBasket();

  const [step, setStep] = useState(1);
  const [data, setData] = useState<any>(null);
  const intl = useIntl();

  const valids = [
    Yup.object({
      firstName: Yup.string().required(intl.formatMessage({ id: 'GLOBAL.VALIDATION.REQUIRED_FIELD' })),
      lastName: Yup.string().required(intl.formatMessage({ id: 'GLOBAL.VALIDATION.REQUIRED_FIELD' })),
      addressLine: Yup.string().required(intl.formatMessage({ id: 'GLOBAL.VALIDATION.REQUIRED_FIELD' })),
      city: Yup.string().required(intl.formatMessage({ id: 'GLOBAL.VALIDATION.REQUIRED_FIELD' })),
      state: Yup.string().required(intl.formatMessage({ id: 'GLOBAL.VALIDATION.REQUIRED_FIELD' })),
      zipCode: Yup.string().required(intl.formatMessage({ id: 'GLOBAL.VALIDATION.REQUIRED_FIELD' })),
      country: Yup.string().required(intl.formatMessage({ id: 'GLOBAL.VALIDATION.REQUIRED_FIELD' })),
    }),
    Yup.object({
      cardName: Yup.string().required(intl.formatMessage({ id: 'GLOBAL.VALIDATION.REQUIRED_FIELD' })),
      cardNumber: Yup.string().required(intl.formatMessage({ id: 'GLOBAL.VALIDATION.REQUIRED_FIELD' })).test('len', intl.formatMessage({ id: 'GLOBAL.VALIDATION.CARD_16' }), val => val.toString().length === 16),
      cardExpiryMonth: Yup.string().required(intl.formatMessage({ id: 'GLOBAL.VALIDATION.REQUIRED_FIELD' })),
      cardExpiryYear: Yup.string().required(intl.formatMessage({ id: 'GLOBAL.VALIDATION.REQUIRED_FIELD' })),
      cardCvv: Yup.string().required(intl.formatMessage({ id: 'GLOBAL.VALIDATION.REQUIRED_FIELD' })).test('len', intl.formatMessage({ id: 'GLOBAL.VALIDATION.DIGIT_3' }), val => val.toString().length === 3),
    }),
  ];

  async function _handleSubmit(values, actions) {
    if (step === 3) {
      setData({
        firstName: values.firstName,
        lastName: values.lastName,
        addressLine: values.addressLine,
        city: values.city,
        state: values.state,
        zipCode: values.zipCode,
        country: values.country,
        orderNo: '64616-103',
        orderDate: 'Jan 07, 2020',
        paymentType: 'Credit Card',
        paymentStatus: 'Paid',
        paymentDate: 'Jan 07, 2020',
        totalPaid: '1,200.00',
        items: basket?.basketItemList
      });

      await mutateAsync({ basketId: basketId });
    } else {
      setStep(step + 1);
      actions.setTouched({});
      actions.setSubmitting(false);
    }
  }

  if (data) return <StepSuccess values={data} />

  return (
    <div className="card card-custom card-transparent">
      <div className="card-body p-0">

        <div className="wizard wizard-4" id="kt_wizard">
          <StepHeader step={step} setStep={setStep} />

          <div className="card card-custom card-shadowless rounded-top-0">
            <div className="card-body p-0">
              <div className="row justify-content-center py-8 px-8 py-lg-15 px-lg-10">
                <div className="col-xl-12 col-xxl-7">
                  <Formik
                    validationSchema={valids[step - 1]}
                    initialValues={{
                      firstName: '',
                      lastName: '',
                      addressLine: '',
                      city: '',
                      state: '',
                      zipCode: '',
                      country: '',
                      cardName: '',
                      cardNumber: '',
                      cardExpiryMonth: '',
                      cardExpiryYear: '',
                      cardCvv: '',
                    }}
                    onSubmit={_handleSubmit}
                  >
                    {({ errors, touched }) => {
                      return (
                        <Form className="form mt-0 mt-lg-10 fv-plugins-bootstrap fv-plugins-framework">
                          {step === 1 && <StepOne />}
                          {step === 2 && <StepTwo />}
                          {step === 3 && <StepThree />}

                          <div className="d-flex justify-content-between border-top mt-5 pt-10">
                            <div className="mr-2">
                              {step !== 1 && (
                                <button
                                  type="button"
                                  className="btn btn-light-primary font-weight-bolder text-uppercase px-9 py-4"
                                  onClick={() => {
                                    setStep(step - 1)
                                  }}
                                >
                                  {intl.formatMessage({ id: 'GLOBAL.BUTTON.PREVIOUS' })}
                                </button>
                              )}
                            </div>
                            <div>
                              {step === 3 && (
                                <button
                                  type="submit"
                                  className="btn btn-success font-weight-bolder text-uppercase px-9 py-4"
                                >
                                  {intl.formatMessage({ id: 'GLOBAL.BUTTON.SUBMIT' })}
                                </button>
                              )}

                              {step !== 3 && (
                                <button
                                  type="submit"
                                  className="btn btn-primary font-weight-bolder text-uppercase px-9 py-4"
                                >
                                  {intl.formatMessage({ id: 'GLOBAL.BUTTON.NEXT' })}
                                </button>
                              )}
                            </div>
                          </div>
                        </Form>
                      )
                    }}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
